<template>
    <div class="row mb-3">
        <div class="col-lg-4">
            <DriverSelect
                @update-driver="updateSelectedDriver"
            />
        </div>
        <div class="col-lg-4">
            <div class="form-group">
                <label class="form-check-label" for="active">
                    <input
                        v-model="filters.active"
                        class="form-check-input me-1"
                        type="checkbox"
                        id="active"
                    >
                    Active
                </label>
            </div>
        </div>
    </div>
    <table ref="tableRef" class="table table-bordered table-striped table-vcenter dataTable" style="width: 100%;">
        <thead>
            <tr>
                <th v-if="!hide.includes('card_number')">Card Number</th>
                <th v-if="!hide.includes('provider')">Provider</th>
                <th v-if="!hide.includes('driver')">Driver</th>
                <th v-if="!hide.includes('active')">Active</th>
                <th v-if="!hide.includes('actions')">Actions</th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>
</template>

<script setup>
import { reactive, onMounted, ref, watch } from "vue";
import { buildColumns } from "@/helpers/build-columns";
import DriverSelect from "@/components/movements/components/DriverSelect.vue";

const props = defineProps({
    ajaxUrl: {
        type: String,
        required: true,
    },
    hide: {
        type: Array,
        default: () => [],
        required: false
    }
});

const tableRef = ref(null);

const filters = reactive({
    active: true,
    driver_id: null,
});

const updateSelectedDriver = (value) => {
    if (value) {
        filters.driver_id = value.id;
    } else {
        filters.driver_id = null;
    }
};

const columnDefinitions = reactive({
    card_number: {
        data: 'card_number',
    },
    provider: {
        data: 'provider',
    },
    driver: {
        data: 'driver.name',
        render: function (data) {
            return data ? data : 'Not set';
        },
    },
    active: {
        data: 'active',
        render: function (data) {
            return data ? 'Yes' : 'No';
        },
    },
    actions: {
        data: 'actions',
        name: 'actions',
        searchable: false,
        orderable: false,
        width: '200px',
    }
});

const setColumnWidths = () => {
    let columnDefs = [];

    if (!props.hide.includes('actions')) {
        columnDefs.push({ targets: -1, width: '200px' });
    }

    return columnDefs;
};

onMounted(() => {
    const table = window.jQuery(tableRef.value).on('preXhr.dt', (e, settings, data) => {
        data.filters = filters;
    }).dataTable({
        processing: true,
        serverSide: true,
        pageLength: 25,
        lengthMenu: [25, 50, 100],
        ajax: {
            url: props.ajaxUrl,
        },
        columnDefs: setColumnWidths(),
        order: [[0, 'asc']], // Sort by Card Number
        columns: buildColumns(columnDefinitions, props.hide),
    });

    // watch filters to reload table when they change
    watch(
        filters,
        () => table.api().ajax.reload(null, false),
        {
            deep: true
        }
    );
});
</script>
